import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { RANKS, SC_TYPES, setRank } from "@/lib/questionRules";
import { Field } from "@/pages/assessments/builder/Field";

export function ScenarioForm({ item, onChange, errs, canEdit }) {
  return (
    <div className="space-y-5" data-testid="scenario-form">
      <Field label="Situation" error={errs.prompt} id="sc-prompt">
        <Textarea id="sc-prompt" rows={5} className="text-base" value={item.scenario} disabled={!canEdit} onChange={(e) => onChange({ ...item, scenario: e.target.value })}
          placeholder="Describe a realistic work situation in 2 to 4 sentences." data-testid="drawer-sc-prompt" />
      </Field>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Type" id="sc-type">
          <select id="sc-type" value={item.type} disabled={!canEdit} onChange={(e) => onChange({ ...item, type: e.target.value })} className="h-10 w-full rounded-lg border border-line bg-white px-2" data-testid="drawer-sc-type">
            {Object.entries(SC_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </Field>
        <Field label="Competency (optional)" id="sc-comp">
          <Input id="sc-comp" value={item.competency || ""} disabled={!canEdit} onChange={(e) => onChange({ ...item, competency: e.target.value })} placeholder="e.g. Ownership" data-testid="drawer-sc-competency" />
        </Field>
      </div>
      <fieldset className="space-y-3">
        <legend className="text-sm font-medium">Four responses, each with a rank</legend>
        {item.options.map((o, i) => (
          <div key={o.id} className="space-y-2 rounded-[6px] border border-line p-3" data-testid={`drawer-sc-response-${i}`}>
            <Textarea rows={2} value={o.text} disabled={!canEdit} aria-label={`Response ${i + 1}`} placeholder={`Response ${i + 1}`}
              onChange={(e) => onChange({ ...item, options: item.options.map((x, j) => (j === i ? { ...x, text: e.target.value } : x)) })} data-testid={`drawer-sc-option-${i}`} />
            <div role="radiogroup" aria-label={`Rank for response ${i + 1}`} className="inline-flex overflow-hidden rounded-full border border-line">
              {RANKS.map(([v, l]) => (
                <button key={v} type="button" role="radio" aria-checked={o.score === v} disabled={!canEdit} onClick={() => onChange({ ...item, options: setRank(item.options, i, v) })}
                  className={`px-3 py-1 text-xs transition-colors ${o.score === v ? "bg-primary text-white" : "bg-white text-ink-secondary hover:bg-surface-2"}`} data-testid={`drawer-sc-rank-${i}-${l.toLowerCase()}`}>{l}</button>
              ))}
            </div>
          </div>
        ))}
        {(errs.options || errs.ranks) && <p className="text-sm text-risk" role="alert">{errs.options || errs.ranks}</p>}
        <p className="text-xs text-ink-muted">Picking a rank that's already used swaps it with that response.</p>
      </fieldset>
    </div>
  );
}
